import io from 'socket.io-client'
import { MIRROR_SOCKET_PATH } from '@/constants'
import Api from '@/api'
import VueRouter from 'vue-router'

class MirrorWebsocket {
  router: VueRouter;
  socket: any;

  constructor (router: VueRouter) {
    this.router = router
  }

  public install (Vue: any) {
    Vue.prototype.$mirrorWebsocket = this
  }

  send (eventName: string, data?: any) {
    this.socket.emit(eventName, data)
  }

  close () {
    this.socket.close()
  }

  init () {
    const token = Api.getToken()

    if (this.socket) {
      this.socket.query.authorization = `Bearer ${token}`
      return
    }

    this.socket = io(MIRROR_SOCKET_PATH!, {
      transports: ['websocket'],
      reconnection: true,
      secure: true,
      query: {
        authorization: `Bearer ${token}`
      }
    })

    this.socket.on('connect', () => {
      if (localStorage) {
        localStorage.setItem('mirrorRoomId', this.socket.id)
      }
    })

    this.socket.on('residentpush', (data: any) => {
      const id = data.id
      if (id) {
        this.router.push({ name: 'management-resident', params: { id, isMirror: 'true' } })
      }
    })
  }
}

export default MirrorWebsocket
